import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/authcontext';
import { LoadingProvider, useLoading } from './context/loadingcontext';
import { initializeAxios } from './utils/axiosconfig';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Room from './pages/Room';
import Checkout from './pages/Checkout';
import ConfirmationPage from './pages/Confirmation';
import PreviousBookingsPage from './pages/PreviousBookings';
import TermsAndCondition from './components/TermsAndCondition';
import PrivacyPolicy from './components/PrivacyPolicy';
import CancellationRefundPolicy from './components/CancellationAndRefund';
import ShippingDeliveryPolicy from './components/ShippingAndDelivery';

function AppContent() {
  const { isLoading, setIsLoading } = useLoading();

  React.useEffect(() => {
    initializeAxios(setIsLoading);
  }, [setIsLoading]);

  return (
    <Router>
      <div className="App" id="page-wrap">
        <Header />
        {isLoading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <ClipLoader color="#ffffff" loading={isLoading} size={50} />
          </div>
        )}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/room" element={<Room />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path='/confirmation/:id' element={<ConfirmationPage />} />
          <Route path='/bookings' element={<PreviousBookingsPage />} />
          <Route path="/terms" element={<TermsAndCondition />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cancellation-refund" element={<CancellationRefundPolicy />} />
          <Route path="/shipping-delivery" element={<ShippingDeliveryPolicy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <LoadingProvider>
        <AppContent />
      </LoadingProvider>
    </AuthProvider>
  );
}

export default App;